import Pages from "../layouts/Pages.jsx";
import App from "../layouts/App.jsx";

var indexRoutes = [
  { path: "/app", name: "App", component: App },
  { path: "/", name: "Pages", component: Pages }
];

export default indexRoutes;
